import TabsContainerComponent from "./TabsContainer";

export default TabsContainerComponent;